import './index.scss'
import { Link } from 'react-router-dom'
import {ReactComponent as Logo} from "../../../assets/logos/logo.svg"
import {ReactComponent as Curve1} from "../../../assets/logos/curve1.svg"
import {ReactComponent as Curve2} from "../../../assets/logos/curve2.svg"
import {ReactComponent as Curve3} from "../../../assets/logos/curve3.svg"
import {ReactComponent as BlueStar} from "../../../assets/logos/blue-star.svg"
import Celebration from "../../../assets/gifs/celebration.gif"
import { useState } from 'react'
import {TailSpin} from 'react-loader-spinner'
import TextField from '@mui/material/TextField';
import { Helmet } from 'react-helmet-async'


const SignUp = () => {

    const [email, setEmail] = useState('');
    const [required, setRequired] = useState(false);
    const [loading, setLoading] = useState(false);
    const [celebrate, setCelebrate] = useState(false);
    const [errorMsg, setErrorMsg] = useState('This field is required');

    const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const typeEmail = (event:React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    }

    const sendMail = async() => {
        const url = `${process.env.REACT_APP_BASE_URL}/sign-up`;
        const data = {email}
        const options = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify(data)
        }
        try{

            const response = await fetch(url, options)
    
            if(response.ok){
                setLoading(false)
                setCelebrate(true)
                const data = await response.json()
                console.log(data)
            }
            else{
                throw new Error("failed to submit a request");
            }
        } catch(error:any){
            setLoading(false)
            console.error('Error in sending email:', error.message);
        }

    }

    const clickSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
        if(email !== ''){
            if(pattern.test(email)){
                setLoading(true)
                setRequired(false);
                setErrorMsg('')
                sendMail();
            }
            else{
                setRequired(true)
                setErrorMsg('Please enter a valid email')
            }
        }
        else{
            setRequired(true)
            setErrorMsg('Please enter a valid email')
        }
    }

    const checkEmail = (event:React.FocusEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        if(!pattern.test(inputValue)){
            setRequired(true)
            setErrorMsg('Please enter a valid email')
        }
        if(inputValue === ''){
            setRequired(true)
            setErrorMsg('This field is required')
        }
        if(pattern.test(inputValue)){
            setRequired(false)
            setErrorMsg('')
        }
    }

    return(
        <>
        <Helmet>
            <title>Walkzero: Join the Future of HRM | HCM</title>
        </Helmet>
        <div className='d-flex flex-column justify-content-start w-100 align-items-center bg-col-new-light-blue-200 position-relative p-t-50 p-b-120 signup-height'>
            <div className='w-90 d-flex flex-row justify-content-start align-self-center m-b-20'>
                <Link className='' to="/"><Logo width={"73%"} className="logo-height" /></Link>
            </div>
            <div className='sign-up-cont align-self-center'>
                <p className='col-quaternary font-weight-6 text-12 text-uppercase mb-0 text-center'>Your all-in-one HRMS software for seamless management</p>
                <h1 className='col-container-font font-weight-6 h1-size m-t-8 m-b-16'>Sign up for free <span className='col-secondary'>Walkzero</span></h1>
                <p className='font font-weight-3 text-12 m-t-0 text-center hide-mb'>Experience the power of our comprehensive HR management platform. <br /> Simply enter your business email address below to get started.</p>
                <p className='font font-weight-3 text-12 m-t-0 text-center show-mb'>Experience the power of our comprehensive HR management platform. Simply enter your business email address below to get started.</p>
                <p className='font-1 font-weight-6 text-16 col-black m-t-20 m-b-40 text-center hide-mb'>Empower Your HR Journey: Streamline, Engage, Succeed.</p>
                <p className='font-1 font-weight-6 text-16 col-black m-t-20 text-center mb-0 show-mb'>Empower Your HR Journey:</p>
                <p className='font-1 font-weight-6 text-16 col-secondary m-b-40 text-center mt-0 show-mb'>Streamline, Engage, Succeed.</p>
                <div className='position-relative d-flex flex-column justify-content-center align-items-center rounded-21 p-t-30 p-b-30 p-l-30 p-r-30 signup-form-bg'>
                    {!celebrate && <><h1 className="col-container-font font-weight-6 h1-size z-index-1 text-center mb-4">Join the Future of <span className='col-secondary'>HRM</span></h1>
                    <form onSubmit={clickSubmit} className='w-100 d-flex flex-column justify-content-start align-items-center' noValidate>
                        <TextField error={required?true:false} className='inputs' required id="outlined-basic" label="Business Email" variant="outlined" size="small" type="email" helperText={required?errorMsg:""} value={email} onBlur={checkEmail} onChange={typeEmail} />
                        {/* {required && <p className='text-11 font-1 font-weight-500 text-danger m-t-3 align-self-start m-l-14'>This field is required</p>} */}
                        <button type="submit" className='bg-col-secondary rounded-9 text-16 font-weight-6 demo-btn align-self-center m-t-30 m-b-10'>Submit Request</button>
                        {loading && <TailSpin visible={true} height="30" width="30" color="#f45600" ariaLabel="tail-spin-loading" radius="1" />}
                    </form>
                    <p className='text-12 font-1 font-weight-4 new-gray-900 text-center'>By Providing your information, you hereby consent to the Walkzero <Link to="" className='decoration'>Cookie Policy</Link> and <Link to="" className='decoration'>Privacy Policy</Link>.</p></>}
                    {celebrate &&<div className='d-flex flex-column justify-content-center align-items-center'>
                        <div className='d-flex justify-content-between w-100 m-t--40'>
                            <img src={Celebration} alt="gif" />
                            <img src={Celebration} alt="gif" />
                        </div>
                        <h1 className='col-container-font font-weight-6 h1-size m-t--90 m-b-16'>Thank <span className='col-secondary'>you!</span></h1>
                        <p className='text-12 font-1 font-weight-4 new-gray-900 text-center'>Your request has been received, and our sales team will reach out to you shortly to provide further assistance and get you started with your account.</p>
                    </div>}
                </div>
            </div>
            <Curve1 className='position-absolute bottom-0 left-percentage-30 z-index--1 med-opacity' />
            <Curve2 className='position-absolute top--50 right--10 z-index--1' />
            <Curve3 className='position-absolute top--60 left--30 z-index--1 med-opacity' />
            <BlueStar className='position-absolute top-80 right-percentage-10 z-index--1' />
            <BlueStar width={20} height={20} className='position-absolute top-110 right-percentage-9 z-index--1' />
        </div>
        </>
    )
}

export default SignUp